import React, { useEffect } from 'react';
import { Box } from '@mui/material';

const AdSenseWidget = ({ client = 'ca-pub-1234567890123456', slot = '1234567890', format = 'auto', responsive = 'true' }) => {
    useEffect(() => {
        try {
            if (window) {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        } catch (err) {
            console.error('AdSense Error:', err);
        }
    }, []);

    return (
        <Box sx={{ width: '100%', my: 2, textAlign: 'center', overflow: 'hidden' }}>
            <ins
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client={client}
                data-ad-slot={slot}
                data-ad-format={format}
                data-full-width-responsive={responsive}
            />
        </Box>
    );
};

export default AdSenseWidget;
